import { useCallback } from 'react';

import { useCareerFeedAIAssistant } from './useCareerFeedAIAssistant';
import { useRecommendationForCareerFeedAiAssistant } from './useRecommendationForCareerFeedAiAssistant';

/**
 * This hook is used to reset the candidate chat context and refresh the recommendations
 */
export const useGetResetCandidateChatContext = () => {
  const { clearCandidateChatContext, reset } = useCareerFeedAIAssistant();

  const { refresh } = useRecommendationForCareerFeedAiAssistant();

  const resetPreferences = useCallback(() => {
    clearCandidateChatContext();
    refresh({ candidateChatContext: null });
    reset();
  }, [clearCandidateChatContext, refresh, reset]);
  return resetPreferences;
};

/**
 * This hook is used to refresh the recommendations with the latest candidate chat context from the context.
 */
export const useGetRefreshRecommendationsWithCandidateChatContext = () => {
  const { candidateChatContext, persistCandidateChatContext } =
    useCareerFeedAIAssistant();
  const { refresh } = useRecommendationForCareerFeedAiAssistant();

  return useCallback(async () => {
    const result = await refresh({
      candidateChatContext,
    });
    persistCandidateChatContext();
    return result;
  }, [refresh, candidateChatContext, persistCandidateChatContext]);
};
